import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Moon, BookOpen, Heart, ClipboardList, Users, CheckCircle2 } from 'lucide-react';
const features = [{
  icon: ClipboardList,
  title: 'Plan de 6 Semanas',
  description: 'Ejercicios guiados día a día para reentrenar tu cerebro y cuerpo para el descanso profundo.'
}, {
  icon: BookOpen,
  title: 'Diario del Sueño',
  description: 'Herramienta personalizada para identificar y eliminar tus ladrones de sueño ocultos.'
}, {
  icon: Heart,
  title: 'Sin Medicamentos',
  description: 'Técnicas naturales y conductuales probadas, seguras y sin efectos secundarios.'
}, {
  icon: Users,
  title: 'Especial para 65+',
  description: 'Diseñado considerando los cambios hormonales y físicos propios de nuestra edad.'
}, {
  icon: Moon,
  title: 'Higiene del Sueño',
  description: 'Aprende a preparar tu habitación y tu mente para una noche de paz absoluta.'
}];
export function FeaturesSection() {
  return <section className="py-24 bg-navy-900 text-cream-50 relative overflow-hidden" data-id="element-8">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-9">
        <div className="absolute top-10 left-10 w-64 h-64 bg-gold-500 rounded-full blur-[100px]" data-id="element-10" />
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-cream-100 rounded-full blur-[120px]" data-id="element-11" />
      </div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-12">
        <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-13">
          {/* Left Column: Heading */}
          <div className="lg:w-1/3 sticky top-24" data-id="element-14">
            <FadeIn data-id="element-15">
              <h2 className="text-3xl md:text-4xl font-bold text-cream-50 mb-6 leading-tight" data-id="element-16">
                ¿Qué incluye el programa{' '}
                <span className="text-gold-500" data-id="element-17">Triada Noche Clara</span>?
              </h2>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-18">
                Un sistema completo, fácil de leer y seguir, que te acompaña de
                la mano hacia un descanso reparador.
              </p>
              <ul className="space-y-4" data-id="element-19">
                <li className="flex items-center gap-3 text-lg text-cream-100" data-id="element-20">
                  <CheckCircle2 className="w-6 h-6 text-gold-500 flex-shrink-0" data-id="element-21" />
                  <span data-id="element-22">Letra grande y legible</span>
                </li>
                <li className="flex items-center gap-3 text-lg text-cream-100" data-id="element-23">
                  <CheckCircle2 className="w-6 h-6 text-gold-500 flex-shrink-0" data-id="element-24" />
                  <span data-id="element-25">Lenguaje sencillo, sin tecnicismos</span>
                </li>
                <li className="flex items-center gap-3 text-lg text-cream-100" data-id="element-26">
                  <CheckCircle2 className="w-6 h-6 text-gold-500 flex-shrink-0" data-id="element-27" />
                  <span data-id="element-28">Soporte por correo incluido</span>
                </li>
              </ul>
            </FadeIn>
          </div>

          {/* Right Column: Grid */}
          <div className="lg:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-29">
            {features.map((feature, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-30">
                <div className="bg-navy-800/50 backdrop-blur-sm border border-navy-700 p-8 rounded-xl hover:bg-navy-800 transition-colors" data-id="element-31">
                  <div className="w-14 h-14 bg-navy-900 rounded-lg flex items-center justify-center mb-6 border border-navy-700 text-gold-500 shadow-lg" data-id="element-32">
                    <feature.icon className="w-7 h-7" data-id="element-33" />
                  </div>
                  <h3 className="text-xl font-bold text-cream-50 mb-3 font-serif" data-id="element-34">
                    {feature.title}
                  </h3>
                  <p className="text-gray-300 leading-relaxed" data-id="element-35">
                    {feature.description}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}